<template>
  <div class="col">
    <v-dialog
      v-model="showDisabledEmpDayDialog"
      v-show="showDisabledEmpDayDialog"
      max-width="590"
      eager
    >
      <v-card>
        <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
          <v-toolbar-title>
            {{ getString("Assenza collaboratore") }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <h3>
                {{
                  getString(
                    "Inserisci un intervallo di giorni in cui il dipendente è assente"
                  )
                }}
              </h3>
            </v-flex>
            <v-flex xs6>
              <v-menu
                ref="dp3"
                :close-on-content-click="false"
                v-model="dp3"
                :nudge-right="40"
                :return-value.sync="dateStart"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateStart"
                  :label="getString('Da')"
                  prepend-icon="event"
                  readonly
                  color="red lighten-2"
                ></v-text-field>
                <v-date-picker
                  :locale="locale"
                  :title-date-format="formatTitle"
                  show-current
                  color="red lighten-2"
                  v-model="dateStart"
                  @input="$refs.dp3.save(dateStart)"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs6>
              <v-menu
                ref="dp4"
                :close-on-content-click="false"
                v-model="dp4"
                :nudge-right="40"
                :return-value.sync="dateEnd"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateEnd"
                  :label="getString('A')"
                  prepend-icon="event"
                  readonly
                  color="red lighten-2"
                ></v-text-field>
                <v-date-picker
                  :locale="locale"
                  :title-date-format="formatTitle"
                  show-current
                  color="red lighten-2"
                  v-model="dateEnd"
                  @input="$refs.dp4.save(dateEnd)"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12>
              <h3>
                {{
                  getString(
                    "Se hai un messaggio da comunicare ai tuoi clienti riguardo al motivo per cui questo collaboratore è assente, ti preghiamo di inserirlo."
                  )
                }}
              </h3>
              <label>{{ getString("Messaggio") }}</label>
              <editor
                v-if="showEditor"
                api-key="vn43j4ndioj2ysq09jicr7yfha8fvqcp8kye03mrgsixspv4"
                v-bind:label="getString('Messaggio da comunicare')"
                v-model="message"
                :init="{
                  selector: 'textarea',
                  language_url: '../../static/languages/tinymce/it.js',
                  menubar: false,
                  min_height: 300,
                  branding: false,
                }"
              ></editor>
            </v-flex>
            <v-flex xs12 style="text-align: right;">
              <v-btn
                @click="() => this.showDisabledEmpDayDialog = false"
               class="q-orange q-whitesmoke-bk bold"
                >{{ getString("Chiudi") }}
              </v-btn>
              <v-btn
                @click="() => disableEmployeeDays()"
                class="q-orange-bk q-text-whitesmoke bold"
                >{{ getString("Salva assenza") }}
              </v-btn>
             
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showEnabledEmpDayDialog"
      v-if="showEnabledEmpDayDialog"
      max-width="590"
    >
      <v-card>
        <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
          <v-toolbar-title>
            {{ getString("Assenza collaboratore") }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <h3>
                {{
                  getString(
                    "Inserisci l'intervallo di giorni in cui il dipendente è tornato"
                  )
                }}
              </h3>
            </v-flex>
            <v-flex xs6>
              <v-menu
                ref="dp1"
                :close-on-content-click="false"
                v-model="dp1"
                :nudge-right="40"
                :return-value.sync="dateStart"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateStart"
                  :label="getString('Da')"
                  prepend-icon="event"
                  readonly
                  color="red lighten-2"
                ></v-text-field>
                <v-date-picker
                  :locale="locale"
                  :title-date-format="formatTitle"
                  show-current
                  color="red lighten-2"
                  v-model="dateStart"
                  @input="$refs.dp1.save(dateStart)"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs6>
              <v-menu
                ref="dp2"
                :close-on-content-click="false"
                v-model="dp2"
                :nudge-right="40"
                :return-value.sync="dateEnd"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="dateEnd"
                  :label="getString('A')"
                  prepend-icon="event"
                  readonly
                  color="red lighten-2"
                ></v-text-field>
                <v-date-picker
                  :locale="locale"
                  :title-date-format="formatTitle"
                  show-current
                  color="red lighten-2"
                  v-model="dateEnd"
                  @input="$refs.dp2.save(dateEnd)"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 class="center">
              <v-btn
                @click="() => enableEmployeeDays()"
                class="q-orange-bk q-text-whitesmoke"
                >{{ getString("Salva") }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-progress-linear
      indeterminate
      v-if="isDisabling"
      :active="true"
      color="red"
      :height="2"
    ></v-progress-linear>

    <div class="emp-name">
      <h4>{{ emp.name }}</h4>

      <div style="height: 20px">
        <v-tooltip bottom>
          <h4 class="red" v-if="isNotAvailable" slot="activator">IN FERIE</h4>
          <span v-html="isNotAvailable ? isNotAvailable.message : ''"></span>
        </v-tooltip>
      </div>
    </div>
    <v-layout row style="width: 240px">
      <v-flex xs12>
        <v-tooltip top>
          <div
            slot="activator"
            class="absent hover"
            @click="() => disableEmployeeDay(true)"
          >
            <v-icon color="red">transfer_within_a_station</v-icon>
          </div>
          <span
            >Blocca la possibilità di prenotarsi con questo dipendente per tutta
            la giornata</span
          >
        </v-tooltip>
      </v-flex>
      <v-flex xs12>
        <v-tooltip top>
          <div
            slot="activator"
            class="absent hover"
            @click="() => disableEmployeeDay(false)"
          >
            <v-icon color="green">transfer_within_a_station</v-icon>
          </div>
          <span
            >Sblocca la possibilità di prenotarsi con questo dipendente per tutta
            la giornata</span
          >
        </v-tooltip>
      </v-flex>

    </v-layout>
    <!-- <cell minutes="00" :hour="9" @deselectOnly="deselectOnly" @move="move" :selectedCard="sCard" @deselectCard="clearSelected" :emp="1" :isClosed="true"></cell> -->
    <template v-for="(item, index) in cells.times">
      {{ regCell(index) }}
      <cell
        :ref="'item' + index"
        @appendCard="appendCard"
        :checkAvailable="notAvailable"
        @addNew="addNew"
        :key="index"
        :minutes="item.i.split(':')[1]"
        :hour="item.i.split(':')[0]"
        @details="details"
        @multiDetails="multiDetails"
        @move="move"
        :test="false"
        :selectedCard="sCard"
        :dow="dow"
        @deselectCard="clearSelected"
        :emp="colorIndex"
        :empId="emp.idEmployee"
        :day="day"
        :isClosed="!item.isOpen || isClosedDay"
        v-if="cellsVis[index]"
        :shop="shop"
        @siteAlert="siteAlert"
        @siteAlertSuccess="siteAlertSuccess"
        :openTM="cells.openTimeMorning"
        :na="na"
        :ferie="isNotAvailable"
        :closeTM="cells.closeTimeMorning"
        :openAF="cells.openTimeAft"
        :closeAF="cells.closeTimeAft"
        :full-date="fullDate"
        v-observe-visibility="
          (isVisible, entry) => visibilityChanged(isVisible, entry, index)
        "
      ></cell>
    </template>
  </div>
</template>

<script>
import Utils from "../../../utils.js";
import cell from "./CalCell";
import ajax from "../../../ajax.js";
import Editor from "@tinymce/tinymce-vue";
import moment from "moment";

var ut = new Utils();
export default {
  name: "CalCol",
  components: {
    cell,
    editor: Editor,
  },
  props: {
    dow: {
      type: Number,
      default: 0,
    },
    na: {
      type: Array,
      default: 0,
    },
    shop: {
      type: Number,
      default: 0,
    },
    fullDate: {
      type: String,
      default: "",
    },
    day: {
      type: String,
      default: "1",
    },
    colorIndex: {
      type: Number,
      default: 0,
    },
    emp: {
      type: Object,
      default: {
        idEmployee: 0,
        name: "",
      },
    },
    isClosedDay: {
      type: Boolean,
      default: false,
    },
    cells: {
      type: Object,
      default: () => {
        return {
          times: [],
          isOpen: false,
        };
      },
    },
  },

  mounted: function () {},
  computed: {
    locale: function () {
      return this.$store.state.currentTranslator.locale;
    },
    isHour: function () {
      if (this.minutes === "00") return true;
      return false;
    },
    isNotAvailable: function () {
      var found = this.na.find(
        (x) => x.date == this.fullDate && x.start == null && x.end == null
      );
      if (found) {
        return found;
      } else {
        return null;
      }
    },
  },
  data: () => {
    return {
      showDisabledEmpDayDialog: false,
      showEnabledEmpDayDialog: false,
      dateStart: new moment().format("YYYY-MM-DD"),
      dateEnd: new moment().format("YYYY-MM-DD"),
      dp1: false,
      dp2: false,
      dp3: false,
      dp4: false,
      message: "",
      sCard: {},
      cellsVis: [],
      isDisabling: false,
      notAvailable: false,
      showEditor: false,
    };
  },

  methods: {
    getString: function (key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
    formatTitle: function (d) {
      var options = {
        weekday: "long",
      };
      return ut.Capitalize(new Date().toLocaleString(this.locale, options));
    },
    refreshEmp: function () {
      this.$emit("refreshEmp", {});
    },
    handleShowDisableDayDialog: function () {
      this.dateStart = new moment(this.fullDate).format("YYYY-MM-DD");
      this.dateEnd = new moment(this.fullDate).format("YYYY-MM-DD");
      this.showDisabledEmpDayDialog = true;
      this.$nextTick(() => {
        this.showEditor = true;
      });
    },
    handleShowEnableDayDialog: function () {
      this.dateStart = new moment(this.fullDate).format("YYYY-MM-DD");
      this.dateEnd = new moment(this.fullDate).format("YYYY-MM-DD");
      this.showEnabledEmpDayDialog = true;
    },
    disableEmployeeDays: function () {
      let self = this;
      this.showDisabledEmpDayDialog = false;
      this.showEditor = false;

      if (this.isDisabling) {
        this.$emit("siteAlert", "Operazione già in corso, attendi che finisca");
        return;
      }
      this.isDisabling = true;
      ajax.axios
        .put(
          ajax.baseUrl() +
            "/admin/calendar/shop/" +
            self.shop +
            "/employee/" +
            self.emp.idEmployee +
            "/from/" +
            self.dateStart +
            "/to/" +
            self.dateEnd +
            "/disable/",
          { message: self.message },
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          if (response) {
            self.refreshEmp();
          }
          setTimeout(() => {
            self.isDisabling = false;
          }, 200);
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
          setTimeout(() => {
            self.isDisabling = false;
          }, 200);
        });
    },
    enableEmployeeDays: function () {
      let self = this;
      self.showEnabledEmpDayDialog = false;
      if (this.isDisabling) {
        this.$emit("siteAlert", "Operazione già in corso, attendi che finisca");
        return;
      }
      this.isDisabling = true;
      ajax.axios
        .put(
          ajax.baseUrl() +
            "/admin/calendar/shop/" +
            self.shop +
            "/employee/" +
            self.emp.idEmployee +
            "/from/" +
            self.dateStart +
            "/to/" +
            self.dateEnd +
            "/enable/",
          {},
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          if (response) {
            self.refreshEmp();
          }
          setTimeout(() => {
            self.isDisabling = false;
          }, 200);
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
          setTimeout(() => {
            self.isDisabling = false;
          }, 200);
        });
    },
    disableEmployeeDay: function (isDisable) {
      let self = this;
      if (this.isDisabling) {
        this.$emit("siteAlert", "Operazione già in corso, attendi che finisca");
        return;
      }
      this.isDisabling = true;
      ajax.axios
        .put(
          ajax.baseUrl() +
            "/admin/calendar/shop/" +
            self.shop +
            "/employee/" +
            self.emp.idEmployee +
            "/date/" +
            self.fullDate +
            "/isDisabled/" +
            isDisable,
          {},
          {
            headers: {
              Authorization: "Bearer " + self.$store.getters.token,
            },
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          if (response) {
            self.refreshEmp();
          }
          setTimeout(() => {
            self.isDisabling = false;
          }, 200);
        })
        .catch(function (error) {
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
          setTimeout(() => {
            self.isDisabling = false;
          }, 200);
        });
    },
    // disableDay: function() {
    //   let temp = []
    //   let i = 0
    //   for (var key in this.$refs) {
    //     temp[i++] = this.$refs[key][0]
    //   }
    //   let j = 0
    //   var x = setInterval(function(){
    //     temp[j++].disableEmployee()
    //     if(j === i)
    //     {
    //       clearInterval(x)
    //     }
    //   },100)
    // },
    siteAlert: function (val) {
      this.$emit("siteAlert", val);
    },
    siteAlertSuccess: function (val) {
      this.$emit("siteAlertSuccess", val);
    },
    details: function (val) {
      this.$emit("details", val);
    },
    multiDetails: function (val) {
      this.$emit("multiDetails", val);
    },
    appendCard: function (val) {
      this.$emit("appendCard", val);
    },
    regCell: function (index) {
      this.cellsVis[index] = true;
    },
    visibilityChanged: function (isVisible, entry, i) {
      this.cellsVis[i] = isVisible;
    },
    clearSelected: function () {},
    move: function (card) {
      this.$emit("move", card);
    },
    addNew: function (val) {
      this.$emit("addNew", val);
    },
    requestCard: function () {},
  },
};
/*
{
  "nameEmployee": null,
  "photo": null,
  "uName": null,
  "uSurname": null,
  "idReservation": 0,
  "dateAndTime": "0001-01-01T00:00:00",
  "dateEnd": "0001-01-01T00:00:00",
  "referenceUsers": 0,
  "referenceBarberShop": 0,
  "referenceEmployee": 0,
  "state": 0,
  "note": null,
  "service": null,
  "flyName": null,
  "flySurname": null,
  "flyPhone": null
} */
</script>

<style scoped>
.col .cell:first-of-type {
  border-top: solid thin #ddd;
}

.col {
  text-align: left;
  position: relative;
}

.loadingWrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: grey;
  z-index: 1;
  opacity: 0.5;
}

.emp-name {
  text-align: center;
  padding-right: 30px;
  text-transform: uppercase;
}

.absent {
  text-align: center;
  color: white;
  height: 30px;

  border: solid thin #ddd;
  background: var(--background-color);
  transition: all 0.3s linear;
}

.absent:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/pieces/CalCol.vue